module.exports = __webpack_public_path__ + "img/xzIco (3).a7a8e8ed.png";